export const ADD_COURSE = "ADD_COURSE";
export const UPDATE_COURSE = "UPDATE_COURSE";
export const DELETE_COURSE = "DELETE_COURSE";
export const SET_COURSE = "SET_COURSE";
export const SET_PRE_COLLEGE_COURSES = "SET_PRE_COLLEGE_COURSES";
export const SET_CERT_COURSES = "SET_CERT_COURSES"